/* eslint-disable no-console */
import {Divider, Flex} from 'antd';
import React from 'react';

import {formatIndian} from '../../../../utils/formatIndian';
import {convertGjToTjWithUnit} from '../../../../utils/formatValueWithUnit';
import CircleComponent from '../../components/CircleComponent';

const LineLegend: React.FC<{
  index: number;
  item: any;
  length: number;
  isCost?: boolean;
  convertToTJ?: boolean;
}> = ({index, item, length, isCost, convertToTJ}) => {
  const isArray = Array.isArray(item?.fill);

  return (
    <>
      <Flex key={index} justify="space-around" gap="3%" align="center">
        <CircleComponent color={isArray ? item?.fill?.[0] : item?.fill} />
        <div className="scope">{item?.label}</div>
        <div className="percentageValue">
          {item?.percentage
            ? item?.percentage?.toString().endsWith('%')
              ? item?.percentage
              : `${item?.percentage} %`
            : '0 %'}
        </div>
        <div className="value">
          {isCost ? (
            <>
              {
                <>
                  <span>{item?.unit ?? ''}</span>
                  {` ${formatIndian(item?.value ?? 0)} `}
                </>
              }
            </>
          ) : (
            <>
              {convertToTJ ? (
                convertGjToTjWithUnit(item?.value || 0, item?.unit ?? '')
              ) : (
                <>
                  {`${formatIndian(item?.value ?? 0)} `}
                  <span>{item?.unit ?? ''}</span>
                </>
              )}
            </>
          )}
        </div>
      </Flex>
      {length - 1 !== index && (
        <Divider
          dashed={true}
          style={{
            borderColor: '#707070',
            borderWidth: '0.0625rem -0.125rem'
          }}
        />
      )}
    </>
  );
};

export default LineLegend;
